module.exports = __webpack_public_path__ + "static/img/entertainment-small.44db297.jpg";